export default __webpack_public_path__ + "static/media/IOTCloud.2fe546a8.jpg";